<script>
export default {
    name: 'IconNotification'
}
</script>
<template>
    <svg
        class="base-icon icon-notification"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 48a4 4 0 110 8 4 4 0 010-8zm-20-4v-6h4V28c0-8.16 6.107-14.892 14-15.876V8h4v4.124c7.893.984 14 7.717 14 15.876v10h4v6H12z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
